export enum TaxesRouteNames {
	SelfCertify = "self-certify",
	SelfCertifyTrade = "self-certify-trade",
	CryptoDeclarationTrade = "crypto-declaration-trade",
	CryptoDeclaration = "crypto-declaration",
	Confirmation = "confirmation",
	Success = "success",
	SingleDeposit = "single-deposit",
	SingleBuyDate = "single-buy-date",
	SwapQuestion = "swap-question",
	CancelModal = "cancel-modal",
	SellTrade = "sell-trade",
	SwapTrade = "swap-trade",
	MarginTrading = "margin-trading",
	SuccessTaxInfo = "success-tax-info",
	SellOrderTrade = "sell-order-trade"
}

export enum SelfCertificationModel {
	Unconfirmed = "UNCONFIRMED",
	Eligible = "ELIGIBLE",
	NonEligible = "NOT_ELIGIBLE"
}

export enum TaxesTransactionTypes {
	Declared = "DECLARED",
	Undeclared = "UNDECLARED",
	Not_Declarable = "NOT_DECLARABLE"
}

export interface SplitWarningModel {
	higherThanFirstBoundary: boolean;
	higherThanSecondBoundary: boolean;
}

export interface TaxesMultiDeclarationModel {
	transactions: TaxesUndeclaredModel[];
}

export interface TaxesUndeclaredModel {
	transactionId: string;
	assetAmount: number;
	assetSymbol: string;
	assetName: string;
	walletId: string;
	assetId: string;
	creditedAt: string;
	assetLogo: string;
}

export interface TaxesUndeclaredSingleModel extends TaxesUndeclaredModel {
	walletTo?: string;
	networkId?: string;
	amountEuro?: string;
}

export interface TaxesUserStatusModel {
	taxStatus?: SelfCertificationModel;
	openDeclarationsCount?: number;
}

export interface TaxesUndeclaredTrxModel {
	transaction_id: string;
	amount: string;
	buy_price?: string;
	from?: string;
	to?: string;
	price_or_date_unknown?: boolean;
	bought_before_cutoff_date?: boolean;
	has_this_token_been_swapped?: boolean;
}

export interface TaxesPriceVerificationModel {
	from_day: string;
	to_day: string;
	base_asset_id: string;
	base_amount: string;
	quote_asset_id: string;
	quote_amount: string;
}

export interface PriceVerificationModel {
	higherThanFirstBoundary: boolean;
	higherThanSecondBoundary: boolean;
}

export interface DeclaredTaxesModel {
	fiat_id: string;
	status: TaxesTransactionTypes;
	declarations: DeclaredTaxesDeclarationModel[];
	fiatId?: string;
}

export interface CapitalGainsTaxModel {
	capitalGain: string;
	taxableAmount: string;
}

export interface DeclaredTaxesDeclarationModel {
	purchase_price: string;
	is_average_price: boolean;
	bought_before_cutoff_point: boolean;
	price_or_date_unknown: boolean;
	purchase_date_from?: string;
	purchase_date_to?: string;
	amount?: string;
}

export enum TaxesConfirmationVariantsModel {
	BoughtBeforeDate = "boughtBeforeDate",
	UnknownPrice = "unknownPrice",
	BuyDateRange = "buyDateRange",
	DateRangeSelected = "dateRange",
	DateOnlySelected = "dateOnly"
}

export enum ToastMessages {
	Success = "self_certification_success_toast_message",
	Error = "self_certification_error_toast_message"
}

export interface ITaxWithheld {
	isTaxServiceAvailable: boolean;
	fiatId: string;
	assetId?: string | null;
	taxAmountFiat: string;
	fiatAmountAfterTax: string | null;
	taxAmountAsset: string | null;
	transactionId: string;
	fiatWalletId: string;
	isSwapBCI: boolean;
	fiatAmountBeforeTax: string | null;
}

export interface ITaxInOffer {
	isTaxable: boolean;
	tax: Partial<ITaxWithheld> | null;
}

export interface ITaxSwap {
	tax: Partial<ITaxWithheld> | null;
	is_taxable: boolean;
}
